import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { LocationStrategy } from "@angular/common";
let ExchangeAddressApprovedModalComponent = class ExchangeAddressApprovedModalComponent {
    constructor(sanitizer, themeService, location) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.location = location;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.textColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.successColor = '';
        this.buttonClicked = false;
        this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
        this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
        this.textColor = this.themeService.getStyleAttribute('text_color');
        this.successColor = this.themeService.getStyleAttribute('success_color');
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
};
ExchangeAddressApprovedModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: LocationStrategy }
];
ExchangeAddressApprovedModalComponent = __decorate([
    Component({
        selector: 'app-exchange-address-approved-modal',
        template: __importDefault(require("./exchange-address-approved-modal.component.html")).default
    })
], ExchangeAddressApprovedModalComponent);
export { ExchangeAddressApprovedModalComponent };
